/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * Makes a POST request sending token.
 * @param {string} accessToken 
 * @param {string} apiEndpoint 
 */
export const callOwnApiWithToken = async(accessToken, apiEndpoint) => {
    const custom_authorization_header = process.env["REACT_APP_AAD_APP_CUSTOM_AUTHORIZATION_HEADER"];
    const reqHeaders = new Headers();
    reqHeaders.append('Content-Type', 'application/json');
    reqHeaders.append(custom_authorization_header, 'Bearer ' + accessToken);

    return fetch(apiEndpoint, {
            method: 'POST',
            headers: reqHeaders,
        }).then(response => response.json())
        .catch(error => console.log(error));
}